import { axiosInstance } from "../../../util/axios";
import { formatWithPlaceholders } from "../../../util/utils";

const fetchWaitedTimeReportId = ({ woNo }) => {
  const uri = formatWithPlaceholders(
    process.env.REACT_APP_CC_FETCH_WEBORDER_REPORT_ID_API_URL_PATH,
    woNo
  );
  const url = `${process.env.REACT_APP_CNC_BASE_API_URL_AE}${uri}`;
  console.log(`fetchWaitedTimeReportId = ${url}`);
  return axiosInstance.get(url, {
    headers: {
      Authorization: `bearer ${process.env.REACT_APP_CNC_HTTP_AUTH_TOKEN_AE}`,
    },
  });
};

const modifyReport = ({
  reportId,
  webOrderNo,
  waitedTime,
  pickupStoreLocation,
  customer_entry,
  handedOverToTransportDt,
  readyForCollectionDt,
  customerArrivedDt,
  handedOverToCollectionPointDt,
  customerCollectedDt,
  ccStatus,
  emailId,
  mobileNo,
  orderValue,
  orderCreationDate,
  orderServiceDate,
  goodsArea,
  woCreatedDt,
}) => {
  const body = {
    weborder_number: webOrderNo,
    pickup_store_location: pickupStoreLocation,
    customer_entry,
    handed_over_to_transport_dt: handedOverToTransportDt,
    handed_over_to_collection_point_dt: handedOverToCollectionPointDt,
    ready_for_collection_dt: readyForCollectionDt,
    customer_arrived_dt: customerArrivedDt,
    customer_collected_dt: customerCollectedDt,
    waited_time: waitedTime,
    cc_status: ccStatus,
    email_id: emailId,
    mobile_number: mobileNo,
    order_value: orderValue,
    order_creation_date: orderCreationDate,
    order_service_date: orderServiceDate,
    goods_area: goodsArea,
    wo_created_dt: woCreatedDt,
  };
  const patchUrl = `${process.env.REACT_APP_CNC_BASE_API_URL_AE}${process.env.REACT_APP_CC_MODIFY_WO_STATUS_REPORT_API_URL_PATH}/${reportId}`;
  console.log(`parseReportId patchUrl = ${patchUrl}`);
  return axiosInstance.patch(patchUrl, body, {
    headers: {
      Authorization: `bearer ${process.env.REACT_APP_CNC_HTTP_AUTH_TOKEN_AE}`,
    },
  });
};

const patchWeborderReport = async ({
  woNo,
  pickupStoreLocation,
  customer_entry,
  handedOverToTransportDt,
  readyForCollectionDt,
  customerArrivedDt,
  handedOverToCollectionPointDt,
  customerCollectedDt,
  ccStatus,
  emailId,
  mobileNo,
  orderValue,
  orderCreationDate,
  orderServiceDate,
  goodsArea,
  woCreatedDt,
}) => {
  console.log(`patchWeborderReport = ${woNo}`);
  const parseReportId = (resp) => resp?.data?.data[0].id;
  try {
    const reportIdResp = await fetchWaitedTimeReportId({
      woNo,
      pickup_store_location: pickupStoreLocation,
    });
    console.log(
      `parseReportId reportIdResp = ${JSON.stringify(
        reportIdResp?.data?.data[0].id
      )}`
    );
    const repId = parseReportId(reportIdResp);
    console.log(`patchWeborderReport repId = ${repId}`);
    await modifyReport({
      reportId: repId,
      pickupStoreLocation,
      customer_entry,
      handedOverToTransportDt,
      readyForCollectionDt,
      customerArrivedDt,
      handedOverToCollectionPointDt,
      customerCollectedDt,
      ccStatus,
      emailId,
      mobileNo,
      orderValue,
      orderCreationDate,
      orderServiceDate,
      goodsArea,
      woCreatedDt,
    });
  } catch (error) {
    console.log(`error = ${error.message}`);
  }
};

export default patchWeborderReport;
